import React, { useEffect, useState } from 'react';
import { Button, Text } from '../../Atoms';
import { Input } from '../../Molecules';
import { PhotoLoginOrganisme } from '../../Organisms';
function TemplateFirstLoginStep2(props) {
  const [showPassword, setShowPassword] = useState(true);
  const [showConfirmPassword, setShowConfirmPassword] = useState(true);
  const [passwordValidation, setPasswordValidation] = useState({
    length: false,
    uppercase: false,
    lowercase: false,
    number: false,
    special: false
  });

  const validatePassword = (password) => {
    const validation = {
      length: password.length >= 8,
      uppercase: /[A-Z]/.test(password),
      lowercase: /[a-z]/.test(password),
      number: /\d/.test(password),
      special: /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password)
    };
    setPasswordValidation(validation);
    return validation;
  };

  const handlePasswordChange = (value) => {
    validatePassword(value);
    props.onChange('password', value);
  };

  useEffect(() => {
    if (props.password.length == 8 && props.confirmPassword.length == 8) {
       if (props.password === '' && props.confirmPassword === '') {
         props.onChange('isValid', true);
       } else if (props.password !== props.confirmPassword) {
         props.onChange('isValid', false);
       } else {
         const allValid = Object.values(passwordValidation).every(v => v);
         props.onChange('isValid', allValid);
       }
      }
  }, [props.password, props.confirmPassword]);

  return (
    <div className="login-template">
      
      <div className="login-template-organism">
          <div className="login-container"> 
                   <Text
                   text="Bienvenue sur votre espace assuré !"
                   type="title-42"
                   className="login-welcome-text"
                 />
                 <div className='first-login-divider' />
                 <div>
                   <Text
                     text="Réinitalisation de votre mot de passe"
                     className="login-title-text"
                   />
                   <div
                     style={{
                       display: 'flex',
                       justifyContent: 'left',
                       alignItems: 'left',
                       marginBottom: 22
                     }}
                   >
              <Text
                text="Définissez un nouveau mot de passe."
                className="text-description-first-login"
              />
            </div>
            <div className="first-login-small-container" style={{width: 'max-content'}}>
              <Input
                placeholder="Nouveau mot de passe"
                className={`input-first-login ${!props.isValid ? 'input-error' : ''}`}
               
                password={showPassword}
                onClickIcon={() => setShowPassword(!showPassword)}
                iconSize={18}
                icon={showPassword ? 'Eye' : 'Eye-closed'}
                iconClassName={'input-first-login-password-icon'}
                onChange={(e) => handlePasswordChange(e.target.value)}
                value={props.password}
              />
              {!props.isValid && (
                <Text
                  type="h8"
                  className="reset-password-error-message"
                  text="Le mot de passe ne correspond pas aux conditions de sécurité requises."
                />
              )}
              <div style={{ paddingTop: 19, width: 'max-content' }}>
                <Input
                  placeholder="Confirmez le nouveau mot de passe"
                  className={`input-first-login relative ${props.password && props.confirmPassword && props.password !== props.confirmPassword ? 'input-error' : ''}`}
                 
                  onClickIcon={() =>
                    setShowConfirmPassword(!showConfirmPassword)
                  }
                  iconSize={18}
                  icon={showConfirmPassword ? 'Eye' : 'Eye-closed'}
                  password={showConfirmPassword}
                  iconClassName={'input-first-login-password-icon'}
                  onChange={(e) =>
                    props.onChange('confirmPassword', e.target.value)
                  }
                  value={props.confirmPassword}
                />
                {props.password && props.confirmPassword && props.password !== props.confirmPassword && (
                  <Text
                    type="h8"
                    className="reset-password-error-message"
                    text="Les mots de passe ne correspondent pas."
                  />
                )}
              </div>
              <div className="password-conditions-container-first-login">
                <Text
                  text="Votre mot de passe doit contenir au minimum :"
                  className="text-description-password-first-login"
                />
                <Text
                  text={`${passwordValidation.length ? '✓' : !props.isValid ? 'x' : '-'} 8 caractères`}
                  className="text-description-password-first-login"
                  style={{ color: passwordValidation.length ? 'green' : !props.isValid ? 'red' : 'inherit' }}
                />
                <Text
                  text={`${passwordValidation.uppercase ? '✓' : !props.isValid ? 'x' : '-'} 1 majuscule`}
                  className="text-description-password-first-login"
                  style={{ color: passwordValidation.uppercase ? 'green' : !props.isValid ? 'red' : 'inherit' }}
                />
                <Text
                  text={`${passwordValidation.lowercase ? '✓' : !props.isValid ? 'x' : '-'} 1 minuscule`}
                  className="text-description-password-first-login"
                  style={{ color: passwordValidation.lowercase ? 'green' : !props.isValid ? 'red' : 'inherit' }}
                />
                <Text
                  text={`${passwordValidation.number ? '✓' : !props.isValid ? 'x' : '-'} 1 chiffre`}
                  className="text-description-password-first-login"
                  style={{ color: passwordValidation.number ? 'green' : !props.isValid ? 'red' : 'inherit' }}
                />
                <Text
                  text={`${passwordValidation.special ? '✓' : !props.isValid ? 'x' : '-'} 1 caractère spécial`}
                  className="text-description-password-first-login"
                  style={{ color: passwordValidation.special ? 'green' : !props.isValid ? 'red' : 'inherit' }}
                />
              </div>
              <div className="btn-confirme-first-login-container">
                <Button
                  text="Confirmer"
                  className="btn-next-first-login"
                  boxShadow
                  onClick={() => props.onSubmit()}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <PhotoLoginOrganisme />
    </div>
  );
}

export default TemplateFirstLoginStep2;
